import { useState, useEffect } from "react";
import { Button } from "@/components/ui/button";
import { Cookie, X } from "lucide-react";
import { Link } from "react-router-dom";

const COOKIE_CONSENT_KEY = "gdzieschronisko_cookie_consent";

export const CookieBanner = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [isClosing, setIsClosing] = useState(false);

  useEffect(() => {
    const checkConsent = () => {
      const consent = localStorage.getItem(COOKIE_CONSENT_KEY);
      if (!consent) {
        const timer = setTimeout(() => setIsVisible(true), 500);
        return () => clearTimeout(timer);
      }
    };

    checkConsent();

    const handleReset = () => {
      setIsClosing(false);
      setIsVisible(true);
    };

    window.addEventListener("cookie-consent-reset", handleReset);
    return () => window.removeEventListener("cookie-consent-reset", handleReset);
  }, []);

  const close = (decision: "accepted" | "declined") => {
    localStorage.setItem(COOKIE_CONSENT_KEY, decision);
    setIsClosing(true);
    setTimeout(() => {
      setIsVisible(false);
      setIsClosing(false);
      window.dispatchEvent(new Event("cookie-consent-change"));
    }, 250);
  };

  const handleAccept = () => close("accepted");
  const handleDecline = () => close("declined");

  if (!isVisible) return null;

  return (
    <div className={`fixed bottom-0 left-0 right-0 z-[1001] p-2 sm:p-4 ${isClosing ? "animate-fade-out" : "animate-fade-in"}`}>
      <div className="relative max-w-4xl mx-auto bg-card border border-border rounded-xl shadow-elevated p-3 pr-8 sm:p-4 sm:pr-4">
        <div className="flex flex-col sm:flex-row items-start sm:items-center gap-2 sm:gap-3">
          <div className="flex items-start sm:items-center gap-2 flex-1">
            <div className="flex-shrink-0 w-7 h-7 bg-primary/10 rounded-md flex items-center justify-center">
              <Cookie className="w-4 h-4 text-primary" />
            </div>
            <p className="text-xs sm:text-sm text-foreground leading-snug">
              Używamy plików cookies i danych lokalizacyjnych. Więcej w{" "}
              <Link to="/polityka-prywatnosci" className="text-primary hover:underline font-medium">
                polityce prywatności
              </Link>.
            </p>
          </div>

          <div className="flex items-center gap-2 w-full sm:w-auto">
            <Button
              variant="outline"
              size="sm"
              onClick={handleDecline}
              className="flex-1 sm:flex-none h-8 px-3 text-xs"
            >
              Odrzuć
            </Button>
            <Button
              size="sm"
              onClick={handleAccept}
              className="flex-1 sm:flex-none h-8 px-3 text-xs"
            >
              Akceptuję
            </Button>
          </div>

          <button
            onClick={handleDecline}
            className="absolute top-1.5 right-1.5 sm:static p-1 text-muted-foreground hover:text-foreground transition-colors"
            aria-label="Zamknij"
          >
            <X className="w-3.5 h-3.5" />
          </button>
        </div>
      </div>
    </div>
  );
};
